import {Component, DestroyRef, inject, OnInit, signal} from '@angular/core';
import {Message} from "primeng/message";
import {FormControl, ReactiveFormsModule, Validators} from "@angular/forms";
import {SelectInputComponent} from '../../../../../../shared/components/input/select-input/select-input.component';
import {KeyNumberFacade} from '../../facade/key-number.facade';
import {DIALOG_DATA, DIALOG_REF, DialogRef} from '../../../../../../shared/components/modals/dialog/model/dialog.model';
import {VehicleKeyAssignModalData} from '../../model/vehicle-key-assign-modal-data.model';
import {AsyncPipe} from '@angular/common';
import {Button} from 'primeng/button';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {filter} from 'rxjs';
import {VehicleKeyAssignModalResult} from '../../model/vehicle-key-assign-modal-result.model';

@Component({
  selector: 'app-vehicle-key-assign-modal',
  imports: [
    Message,
    ReactiveFormsModule,
    SelectInputComponent,
    AsyncPipe,
    Button
  ],
  templateUrl: './vehicle-key-assign-modal.component.html',
  styleUrl: './vehicle-key-assign-modal.component.css',
})
export class VehicleKeyAssignModalComponent implements OnInit {
  private readonly dialogRef: DialogRef<VehicleKeyAssignModalResult> = inject(DIALOG_REF) as DialogRef<VehicleKeyAssignModalResult>;
  private readonly dialogData: VehicleKeyAssignModalData = inject(DIALOG_DATA) as VehicleKeyAssignModalData

  protected keyNumber: FormControl<number | null> = new FormControl<number | null>(null, Validators.required)

  protected isLoading = signal<boolean>(false);

  constructor(
    private readonly destroyRef: DestroyRef,
    private readonly keyNumberFacade: KeyNumberFacade
  ) {
  }

  ngOnInit(): void {
    this.fetchAvailableKeyNumbers();
    this.registerFetchAvailableKeyNumberSubscription();
  }

  protected get facade(): KeyNumberFacade {
    return this.keyNumberFacade;
  }

  protected onCancel(): void {
    this.dialogRef.close();
  }

  protected onApply(): void {
    const result: VehicleKeyAssignModalResult = {
      keyNumber: this.keyNumber.value as number
    }

    this.dialogRef.close(result)
  }

  private fetchAvailableKeyNumbers(): void {
    const storageId = this.dialogData.storageId;
    this.keyNumberFacade.fetchAvailableKeyNumbers(storageId);
  }

  private registerFetchAvailableKeyNumberSubscription(): void {
    this.facade.availableKeyNumbers$
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        filter(keyNumbers => keyNumbers !== null && keyNumbers.length > 0))
      .subscribe(keyNumbers => {
        this.keyNumber.setValue(keyNumbers[0].value)
      });
  }
}
